// Only the standalone ZEZO layout loads this file. Shopify Forms owns saving and success.
const firstDropBound = new WeakSet();
function initializeFirstDrop() {
const firstDropPage = document.querySelector('.first-drop');

// Presentation only: Shopify creates this link in its saved-success response.
// Never create a booking link, infer submission success, or intercept submit here.
const applicationContainer = firstDropPage?.querySelector('.fd-form-container');
if (applicationContainer && !firstDropBound.has(applicationContainer)) {
  firstDropBound.add(applicationContainer);
  const styledForms = new WeakSet();
  const styleBookingLink = () => {
    applicationContainer.querySelectorAll('shopify-forms-embed').forEach((host) => {
      if (!host.closest('[data-forms-id="forms-root-1200240"]')) return;
      const root = host.shadowRoot;
      if (!root || styledForms.has(host)) return;
      styledForms.add(host);
      const style = document.createElement('style');
      style.textContent = `
        a.fd-booking-cta{display:flex!important;align-items:center;justify-content:center;
          min-height:56px;margin:20px 0 0;padding:16px 20px;box-sizing:border-box;
          background:var(--fd-accent,#cf3a27)!important;color:var(--fd-button-ink,#fff)!important;border-radius:var(--fd-button-radius,0);text-decoration:none!important;
          text-align:center;font:700 11px/1.5 Arial,sans-serif;letter-spacing:.7px}
        .fd-booking-note{margin:12px 0 0;font:400 12px/1.6 Arial,sans-serif;color:#5d5b53}
        a.fd-booking-cta:hover{filter:brightness(.9)}
        a.fd-booking-cta:focus-visible{outline:2px solid #191919;outline-offset:4px}
      `;
      root.append(style);
      const decorate = () => {
        if (!style.isConnected) root.append(style);
        // Copy-only fallback while the native Forms editor is unavailable.
        // Change text nodes, never form controls, handlers, values or submission state.
        const replaceLabel = (oldText, newText) => {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          let text;
          while ((text = walker.nextNode())) {
            if (text.nodeValue.trim() === oldText) text.nodeValue = text.nodeValue.replace(oldText, newText);
          }
        };
        replaceLabel('SEND APPLICATION', 'SUBMIT APPLICATION');
        replaceLabel('Tell ZEZO what you want to build. Free application. No payment or marketing signup.',
          'Tell ZEZO about your clothing brand, what you’re working on and where you want to take it. ZEZO reviews applications to find founders who are the right fit for private mentorship.');
        root.querySelectorAll('a[href]').forEach((link) => {
          const url = new URL(link.href, location.href);
          if (url.origin !== 'https://calendar.google.com' || !url.pathname.includes('/appointments/schedules/')) return;
          if (!link.classList.contains('fd-booking-cta') && !['BOOK YOUR FREE CALL WITH ZEZO', 'BOOK YOUR FIT CALL WITH ZEZO'].includes(link.textContent.trim())) return;
          replaceLabel('BOOK YOUR FREE CALL WITH ZEZO', 'BOOK YOUR FIT CALL WITH ZEZO');
          if (link.title === 'BOOK YOUR FREE CALL WITH ZEZO') link.title = 'BOOK YOUR FIT CALL WITH ZEZO';
          link.classList.add('fd-booking-cta');
          const bookingLabel = applicationContainer.dataset.fdBookingLabel?.trim();
          if (bookingLabel && link.textContent.trim() !== bookingLabel) { link.textContent = bookingLabel; link.title = bookingLabel; }
          // The booking link comes only from Shopify's saved-success response.
          const heading = [...root.querySelectorAll('h1,h2,h3')].find((node) =>
            ['APPLICATION SENT.', 'APPLICATION RECEIVED.'].includes(node.textContent.trim()));
          if (heading && !root.querySelector('button[type="submit"]')) {
            replaceLabel('APPLICATION SENT.', 'APPLICATION RECEIVED.');
            const copy = 'Your next step is to book a short call with ZEZO to discuss your brand and see whether working together is the right fit.';
            replaceLabel('Your application is saved. Choose a free 15-minute introduction call.', copy);
            const dialog = heading.closest('[role="dialog"]');
            if (dialog?.getAttribute('aria-label') === 'APPLICATION SENT.') dialog.setAttribute('aria-label', 'APPLICATION RECEIVED.');
            const announcement = root.querySelector('[role="status"] span');
            if (announcement?.textContent.startsWith('APPLICATION SENT. Your application is saved.')) {
              announcement.textContent = `APPLICATION RECEIVED. ${copy} BOOK YOUR FIT CALL WITH ZEZO. Booking a call does not guarantee acceptance.`;
            }
          }
          if (!root.querySelector('.fd-booking-note')) {
            const note = document.createElement('p');
            note.className = 'fd-booking-note';
            note.textContent = 'Booking a call does not guarantee acceptance.';
            (link.closest('p') || link).after(note);
          }
        });
      };
      new MutationObserver(decorate).observe(root, { childList: true, characterData: true, subtree: true });
      decorate();
    });
  };
  customElements.whenDefined('shopify-forms-embed').then(() => {
    styleBookingLink();
    new MutationObserver(styleBookingLink).observe(applicationContainer, { childList: true, subtree: true });
  });
}
const privacyDialog = firstDropPage?.querySelector('#zezo-privacy');
let privacyOpener;

firstDropPage?.querySelectorAll('[data-fd-privacy-open]').forEach((link) => {
  if (firstDropBound.has(link)) return;
  firstDropBound.add(link);
  link.addEventListener('click', (event) => {
    if (!privacyDialog?.showModal || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    privacyOpener = link;
    privacyDialog.showModal();
  });
});
if (privacyDialog && !firstDropBound.has(privacyDialog)) {
firstDropBound.add(privacyDialog);
privacyDialog.querySelector('[data-fd-privacy-close]').addEventListener('click', () => privacyDialog.close());
privacyDialog?.addEventListener('click', (event) => {
  if (event.target !== privacyDialog) return;
  const rect = privacyDialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) privacyDialog.close();
});
privacyDialog.addEventListener('close', () => privacyOpener?.focus({ preventScroll: true }));
}

firstDropPage?.querySelectorAll('a[href^="#"]:not([data-fd-privacy-open])').forEach((link) => {
  if (firstDropBound.has(link)) return;
  firstDropBound.add(link);
  link.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    // Keep normal back/forward behavior and the same page/query (including draft preview).
    if (location.hash !== link.hash) history.pushState(null, '', link.hash);
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
});

// Consent is checked only when a configured ZEZO YouTube facade is clicked.
firstDropPage?.querySelectorAll('[data-fd-youtube]').forEach((container) => {
  if (firstDropBound.has(container)) return;
  firstDropBound.add(container);
  const button = container.querySelector('.fd-video-play');
  const notice = container.querySelector('.fd-video-consent');
  const canPlay = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const showPlayer = () => {
    if (!canPlay()) {
      notice.textContent = 'To watch this YouTube video, allow marketing cookies in the store’s cookie preferences, then select play again.';
      notice.hidden = false;
      return;
    }
    const id = container.dataset.fdYoutube;
    if (!/^[\w-]{11}$/.test(id)) return;
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?rel=0&playsinline=1`;
    frame.title = container.dataset.fdVideoTitle;
    frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    // No autoplay: the visitor retains control of the embedded player.
    button.replaceWith(frame);
    notice.hidden = true;
    frame.focus();
  };
  button.addEventListener('click', () => {
    if (window.Shopify?.customerPrivacy) return showPlayer();
    if (!window.Shopify?.loadFeatures) return showPlayer();
    button.disabled = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
      button.disabled = false;
      showPlayer();
    });
  });
  const onConsent = () => {
    if (canPlay()) return;
    const frame = container.querySelector('iframe');
    if (frame) frame.replaceWith(button);
  };
  document.addEventListener('visitorConsentCollected', onConsent);
  const onUnload = (event) => {
    if (!event.target.contains(container)) return;
    document.removeEventListener('visitorConsentCollected', onConsent);
    document.removeEventListener('shopify:section:unload', onUnload);
  };
  document.addEventListener('shopify:section:unload', onUnload);
});

}
initializeFirstDrop();
document.addEventListener('shopify:section:load', initializeFirstDrop);
